let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jO26g")).then(() => parcelRequire('fbpU5'));